import { defineCatalogue } from '../../../i18n';

export const tseCatalogue = defineCatalogue(
  {
    'mode.tse': 'Buscar no TSE',
    'mode.manual': 'Preencher à mão',
    'election.label': 'Eleição',
    'election.placeholder': 'Escolha a eleição',
    'election.cycle': 'Eleições {year}',
    'scope.MUNICIPAL': 'Municipal',
    'scope.STATE': 'Estadual',
    'scope.FEDERAL': 'Federal',
    'office.label': 'Cargo',
    'office.placeholder': 'Escolha o cargo',
    'office.loading': 'Carregando cargos…',
    'office.empty': 'Nenhum cargo disponível',
    'office.error': 'Não foi possível carregar os cargos agora.',
    'number.label': 'Número',
    'number.placeholder': 'Buscar por nome ou número',
    'state.label': 'Estado',
    'state.placeholder': 'Escolha o estado',
    'state.loading': 'Carregando estados…',
    'state.empty': 'Nenhum estado disponível',
    'state.error': 'Não foi possível carregar os estados agora.',
    'number.digits': 'O número para {office} tem {digits} dígitos.',
    'number.needsOffice': 'Escolha o cargo antes do número.',
    'search.loading': 'Buscando candidatos…',
    'search.empty': 'Nenhum candidato encontrado para esta eleição e este cargo.',
    'search.error': 'Não foi possível buscar candidatos agora.',
    'link.label': 'Ver {name} no TSE',
    remove: 'Remover candidato',
  },
  {
    'mode.tse': 'Search the TSE',
    'mode.manual': 'Fill in by hand',
    'election.label': 'Election',
    'election.placeholder': 'Choose the election',
    'election.cycle': 'Elections {year}',
    'scope.MUNICIPAL': 'Municipal',
    'scope.STATE': 'State',
    'scope.FEDERAL': 'Federal',
    'office.label': 'Office',
    'office.placeholder': 'Choose the office',
    'office.loading': 'Loading offices…',
    'office.empty': 'No office available',
    'office.error': 'Could not load the offices right now.',
    'number.label': 'Number',
    'number.placeholder': 'Search by name or number',
    'state.label': 'State',
    'state.placeholder': 'Choose the state',
    'state.loading': 'Loading states…',
    'state.empty': 'No state available',
    'state.error': 'Could not load the states right now.',
    'number.digits': 'A number for {office} has {digits} digits.',
    'number.needsOffice': 'Choose the office before the number.',
    'search.loading': 'Searching candidates…',
    'search.empty': 'No candidate found for this election and this office.',
    'search.error': 'Could not search candidates right now.',
    'link.label': 'See {name} at the TSE',
    remove: 'Remove candidate',
  },
);

export const tse = tseCatalogue.t;
